import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20and%20inviting%20community%20gathering%20scene%20with%20people%20enjoying%20shared%20hobbies%20together%2C%20soft%20natural%20golden%20light%2C%20friendly%20warm%20atmosphere%2C%20blurred%20background%20with%20bokeh%20effect%2C%20lifestyle%20photography&width=1600&height=700&seq=cta-bg-join&orientation=landscape"
        alt="加入撸撸社"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55"></div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading text-white mb-4">
          准备好加入撸撸社了吗？
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-8 leading-relaxed">
          无论你是手工达人、摄影爱好者，还是美食探索家，撸撸社都欢迎你的到来。
          现在注册，开启你的兴趣之旅，发现更多有趣的人和事。
        </p>
        <Link
          to="/about"
          className="inline-block px-10 py-3.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-all duration-300 whitespace-nowrap"
        >
          立即注册，免费加入
        </Link>
      </div>
    </section>
  );
}